import {Directive, ElementRef} from '@angular/core';
import canAutoPlay from 'can-autoplay';

declare var jwplayer: any;

@Directive({
  selector: '[appJwplayer]'
})
export class JwplayerDirective {

  constructor(el: ElementRef) {
    canAutoPlay.video().then((result) => {

      console.log('canAutoPlay', result);

      jwplayer(el.nativeElement).setup({
        playlist: [
          {
            image: 'https://dl.videos.sportys.com/onlinecourse/images/tvos/p1s1.jpg',
            sources: [
              {
                file: 'https://stream.videos.sportys.com/onlinecourse/ltf/discover.m3u8'
              }
            ]
          }
        ],
        primary: 'html5',
        xheight: 420,
        xwidth: 720,
        width: '100%',
        autostart: result.result,
        aspectratio: '16:9',
        key: '+6qh90LX6SUSRtUIKYSs7JZA8We0seEeyR0Vzm2/YHw='
      });
    });

  }
}

/*
,

        events: {
          onReady: (event) => {
            console.log('onReady', event);
          },
          onPlay: (event) => {
            console.log('onPlay', event);
          },
          onCaptionsList: (event) => {
            console.log('onCaptionsList', event);
          },
          onCaptionsChanged: (event) => {
            console.log('onCaptionsChanged', event);
          },
          onTime: (event) => {
            console.log('onTime', event, player);

          },
          onError: (event) => {
            console.log('onError', event);
          },
          onPause: (event) => {
            console.log('onPause', event, player);
          },
          onSeek: (event) => {
            console.log('onSeek', event, player);
          },
          onSeeked: (event) => {
            console.log('onSeeked', event, player);
          },
          onIdle: (event) => {
            console.log('onIdle', event, player);
          },
          onAll: (event) => {
            console.log('onAll', event, player);
          }


        }
      });

      player.on('all', (event) => {
        console.log('onAll', event);
        console.log('onAll', player.getState());
        if (event === 'userInactive') {
          playing = playing + 1;
        }
        if (playing > 2 && event === 'userInactive') {
          player.stop();
        }
      });

      player.on('autoplayFailed', (event) => {
        console.log('autoplayFailed', event);
      });
 */
